// import React from 'react';
import React, { useState, useEffect } from 'react'
import * as Common from '../../common'
import { useHistory } from 'react-router-dom'

/**
 * ボタンの出し分け
 * ■物件一覧ページ(property)…
 * - Googleマップ
 * - 案件一覧を見る
 * ■購買一覧ページ(purchase)・案件一覧ページ(project)…
 * - 参照
 */
function ResultButton(props: any) {
  const history = useHistory()

  switch (props.pageType) {
    case 'property':
      return (
        <div className="result__button02">
          <input
            type="button"
            value="Googleマップ"
            className="result__button02-btn result__button02-btn--single"
            onClick={() => {
              props.onViewGoogleMap()
            }}
          />
          <input
            type="submit"
            value="案件一覧をみる"
            className="result__button02-btn result__button02-btn--single"
          />
        </div>
      )
    case 'project':
      return (
        <>
          <div className="result__button">
            <input type="submit" value="PDF参照" id="js-view" />
          </div>
          <div className="result__comment">
            前受金請求書については、スマートフォンからは閲覧未対応項目のため閲覧できません
          </div>
          <div className="result__comment">
            当ページで表示される請求書は適格請求書の要件を満たしておりません。取引先への提出はアプリから出力したデータをご利用ください。
          </div>
        </>
      )
    case 'purchase':
      return (
        <>
          <div className="result__button">
            <input type="submit" value="PDF参照" id="js-view" />
          </div>
        </>
      )
    default:
      return <div>pageTypeの値が誤っています</div>
  }
}

/**
 * 表の<tr>の中身
 */
function ResultItem(props: any) {
  /**
   * ラジオボタン
   */
  const radio = React.createRef<HTMLInputElement>()

  /**
   * 見積もりIDから見積もり名を導出する
   * @param id
   * @returns
   */
  const statusNameById = (id: any) => {
    if (Common.STATUS[props.pageType]) {
      for (const i of Common.STATUS[props.pageType]) {
        if (i.id === id) {
          return i.label
        }
      }
    }
    return ''
  }

  /**
   * 都道府県IDから都道府県名を導出する
   * @param slug
   * @returns
   */
  const PrefectureNameByCode = (code: any) => {
    for (const i of Common.PREFECTURES) {
      if (i.code === code) {
        return i.name
      }
    }
    return ''
  }

  /**
   * 内容を出力
   * statusは名前で出力
   * 都道府県は名前で出力
   * それ以外はそのまま出力
   */
  const outputValue = (slug: string) => {
    if (slug === 'status') {
      return statusNameById(props.data.status)
    } else if (slug === 'm_prefecture_id') {
      return PrefectureNameByCode(props.data.m_prefecture_id)
    } else {
      return Common.stringLimited(
        props.data[slug],
        Common.resultItemLengthLimit,
      )
    }
  }

  return (
    <>
      <td>
        <input
          type="radio"
          name="result"
          ref={radio}
          checked={props.isActive ? true : false}
          readOnly
        />
      </td>
      {props.resultItemName.map((data: any, index: any) => {
        // slugがproperty_nameで
        // props.authoritySetting.property_management_flagが0のときは返さない
        return (
          !(
            data.slug === 'property_name' && props.propertyManagementFlag === 0
          ) && <td key={index}>{outputValue(data.slug)}</td>
        )
      })}
    </>
  )
}

/**
 * 表全体
 */
function Result(props: any) {
  /**
   * 選ばれている項目のインデックス
   */
  const [selectedItem, selectItem] = useState<any>(null)

  /**
   * 検索一覧を表示するかどうかの判定
   */
  const [isHiddenPreviewButton, setIsHiddenPreviewButton] =
    useState<boolean>(true)

  /**
   * resultConditionを変更
   * @param value [{変更するキー,値},{変更するキー,値},…]
   */
  const editResultCondition = (value: Array<{ key: any; value: any }>) => {
    //resultConditionのコピーを作成
    const temp = Object.assign({}, props.resultCondition)

    //コピーを書き換え
    value.map((data: any) => {
      temp[data.key] = data.value
    })

    //それを親コンポーネントに送る
    props.onChangeResultCondition(temp)

    //resultConditionが変わるとチェックが外れるので、
    //それを親コンポーネントに伝える
    props.onChangeselectedItemInResult(null)
  }

  useEffect(() => {
    // プレビューボタンの表示設定
    switch (props.pageType) {
      case 'project':
        // 案件ページ
        setIsHiddenPreviewButton(
          props.authoritySetting.project_management_permission === 9,
        )
        break
      case 'purchase':
        // 購買ページ
        // プランでプレミアム以外
        // 発注管理がNot
        // 仕入れ管理がNot かつ 選択中の項目のステータスが仕入れ
        const isHiddenPurcasePreview =
          props.authoritySetting.plan_id !== 4 ||
          props.authoritySetting.order_management_permission === 9 ||
          (props.authoritySetting.purchase_management_permission === 9 &&
            selectedItem &&
            selectedItem.status === 4)

        setIsHiddenPreviewButton(isHiddenPurcasePreview)
        break
      case 'property':
        setIsHiddenPreviewButton(
          props.authoritySetting.property_management_flag === 0,
        )
        break
      default:
        break
    }
  }, [selectedItem])

  return (
    <section className={'result ' + props.pageType + '__result'}>
      <form className="result__inner" onSubmit={props.onSubmit}>
        <div className="result__ttl">
          <h2 className="result__ttl-text">{props.pageTypeJa}一覧</h2>
          <div className="result__ttl-number">
            全{props.resultObject.headers['x-total'] || ''}件
          </div>
        </div>
        <div className="result__content">
          <table className="table result__table">
            <tbody>
              <tr className="table__headline">
                <th>対象</th>
                {props.resultItemName.map((data: any, index: any) => {
                  // slugがproperty_nameで
                  // props.authoritySetting.property_management_flagが0のときは返さない
                  return (
                    !(
                      data.slug === 'property_name' &&
                      props.authoritySetting.property_management_flag === 0
                    ) && (
                      <th
                        key={index}
                        onClick={() => {
                          //editResultConditionで送る値を作る
                          let sendValue: Array<{ key: any; value: any }> = [
                            { key: 'sort', value: data.slug },
                            { key: 'page', value: 1 },
                          ]

                          //同じ箇所を２回クリックすると
                          if (props.resultCondition.sort === data.slug) {
                            //昇順・降順を入れ替えするようにする
                            sendValue.push({
                              key: 'order',
                              value: !props.resultCondition.order,
                            })
                          } else {
                            //そうでない場合、昇順に設定
                            sendValue.push({ key: 'order', value: true })
                          }

                          //クリックした項目名でソート
                          //ページを1に戻す
                          editResultCondition(sendValue)
                        }}
                      >
                        {data.name}
                      </th>
                    )
                  )
                })}
              </tr>
              {props.resultObject.data.map((data: any, index: any) => {
                return (
                  <tr
                    key={index}
                    data-is-chosen={
                      selectedItem && data.id === selectedItem.id ? true : false
                    }
                    onClick={() => {
                      //選ばれた行のIDをselectedItemに格納
                      selectItem(data)
                      //list.tsx(親コンポーネント)に値を送信
                      props.onChangeselectedItemInResult(data)
                    }}
                  >
                    <ResultItem
                      resultItemName={props.resultItemName}
                      pageType={props.pageType}
                      data={data}
                      isActive={
                        selectedItem && data === selectedItem ? true : false
                      }
                      propertyManagementFlag={
                        props.authoritySetting.property_management_flag
                      }
                    ></ResultItem>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <div className="pager result__pager">
          <ul className="pager__list">
            {props.resultCondition.page !== 1 && (
              <li className="pager__item">
                <a
                  className="pager__link pager__link--prev"
                  onClick={() => {
                    editResultCondition([
                      { key: 'page', value: props.resultCondition.page - 1 },
                    ])
                  }}
                >
                  <span className="pager__link-inner"></span>
                </a>
              </li>
            )}
            {props.resultCondition.page !== 1 && (
              <li className="pager__item">
                <a
                  className="pager__link"
                  onClick={() => {
                    editResultCondition([
                      { key: 'page', value: props.resultCondition.page - 1 },
                    ])
                  }}
                >
                  <span className="pager__link-inner">
                    {props.resultCondition.page - 1}
                  </span>
                </a>
              </li>
            )}
            <li className="pager__item">
              <a className="pager__link pager__link--current">
                <span className="pager__link-inner">
                  {props.resultCondition.page}
                </span>
              </a>
            </li>
            {props.resultCondition.page !==
              Number(props.resultObject.headers['x-last_page']) && (
              <li className="pager__item">
                <a
                  className="pager__link"
                  onClick={() => {
                    editResultCondition([
                      { key: 'page', value: props.resultCondition.page + 1 },
                    ])
                  }}
                >
                  <span className="pager__link-inner">
                    {props.resultCondition.page + 1}
                  </span>
                </a>
              </li>
            )}
            {props.resultCondition.page !==
              Number(props.resultObject.headers['x-last_page']) && (
              <li className="pager__item">
                <a
                  className="pager__link pager__link--next"
                  onClick={() => {
                    editResultCondition([
                      { key: 'page', value: props.resultCondition.page + 1 },
                    ])
                  }}
                >
                  <span className="pager__link-inner"></span>
                </a>
              </li>
            )}
          </ul>
        </div>
        {!isHiddenPreviewButton && (
          <ResultButton
            pageType={props.pageType}
            selectedItem={selectedItem}
            //物件一覧で、物件情報を上に送る
            onViewGoogleMap={() => {
              props.onViewGoogleMap()
            }}
          ></ResultButton>
        )}
      </form>
    </section>
  )
}

export default Result
